import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=51444a76&scoped=true"
import script from "./Block.vue?vue&type=script&lang=js"
export * from "./Block.vue?vue&type=script&lang=js"
import style0 from "./Block.vue?vue&type=style&index=0&id=51444a76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51444a76",
  null
  
)

export default component.exports